import HeaderChat from "./components/header-chat";
import React, { useState, useRef, useEffect } from "react";
import Chatbox from "./components/box-chat";
import AttendeesChat from "./components/attendees-chat";
import ActivityChat from "./components/activity-chat";
import Message from "./constants";
import MessageItem from "./components/messenger-chat";
import AgoraRTM from "agora-rtm-sdk";
import useAppAccessor from "../../hooks/useappAccessor";
import useAppDispatch from "../../hooks/useAppDispatch";
import { setStramState } from "../live-main/livemain.actions";
import {
  setInteractionData,
  setActivityInteractionData,
} from "../interactions/interaction.actions";
import { getItemDetailService } from "../../services/shopcom.service";
import { getProductDetails } from "../interactions/interaction.actions";
import { getItemDetailServiceTranont } from "../../services/tranont.service";

import {
  setAttendeeList,
  setAllAttendeeList,
  setHostTime,
  setPersonNum,
  setHostConnectionStatus,
} from "../live-main/livemain.actions";
import {
  List,
  Chatnew,
} from '../../assets/icons';
import { useParams } from "react-router-dom";
import { constants } from "fs/promises";
import {
  showAttendeeCountFunc,
  setPinnedLayoutUid,
  setCopresenterUids,
  setCopresenterInfo,
  turnOffCamera,
  turnOffMic,
  turnOnCamera,
  turnOnMic,
  turnOffHostCamera,
  turnOffHostMic,
  turnOnHostCamera,
  turnOnHostMic,
  toastMess,
} from "../agora-live/components/streamControls/controls.actions";
import { callLeaveStreamWithAttendeeId, callPostAttendeeNumber } from "../../services/main.service";
import _, { add } from "lodash";
import { screens } from "../../constants";
import useAppNavigation from "../../hooks/useAppNavigation";
import { AGORA_APP_ID } from "../../config";
import { getItemDetailServiceForPartnerCo } from "../../services/partnerco.service";

const APP_ID = AGORA_APP_ID;

let client = AgoraRTM.createInstance(APP_ID);
const isHost = () => {
  return window.location.href.indexOf("/stream") > -1;
};
const PINNED_PRESENTER_UID_KEY = "pinned_presenter_uid";

let baselineLayoutH = 0;
let baselineInnerHeight = 0;

const isAndroid = () =>
  /Android/i.test(window.navigator.userAgent);

function startKeyboardTracking() {
  baselineLayoutH =
    window.visualViewport?.height ??
    document.documentElement.clientHeight ??
    window.innerHeight;
  baselineInnerHeight = window.innerHeight;
}

function getKeyboardHeightIOS(): number {
  const vv = window.visualViewport;
  if (!vv) return 0;
  if (!baselineLayoutH) startKeyboardTracking();
  return Math.round(Math.max(0, baselineLayoutH - vv.height));
}

function getKeyboardHeightAndroid(): number {
  const vv = window.visualViewport;
  if (!baselineInnerHeight) startKeyboardTracking();
  const visibleHeight = vv
    ? Math.min(vv.height, window.innerHeight)
    : window.innerHeight;
  return Math.round(Math.max(0, baselineInnerHeight - visibleHeight));
}

function getKeyboardHeight(): number {
  if (isAndroid()) return getKeyboardHeightAndroid();
  return getKeyboardHeightIOS();
}

function subscribeKeyboard(onChange: (h: number) => void) {
  const vv = window.visualViewport;
  const handler = () => onChange(getKeyboardHeight());
  if (vv) {
    vv.addEventListener("resize", handler);
    vv.addEventListener("scroll", handler);
  }
  if (!vv || isAndroid()) {
    window.addEventListener("resize", handler);
  }
  handler();
  return () => {
    if (vv) {
      vv.removeEventListener("resize", handler);
      vv.removeEventListener("scroll", handler);
    }
    if (!vv || isAndroid()) {
      window.removeEventListener("resize", handler);
    }
  };
}

const AgoraChatMobile = (props: any) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const [activeTab, setActiveTab] = useState("chat");
  const [hisotryMSG, setHistoryMSG] = useState<boolean>(false);
  const [keyboardOffset, setKeyboardOffset] = useState(0);
  const [isChatInputFocused, setChatInputFocused] = useState(false);
  const [debugViewport, setDebugViewport] = useState({
    offset: 0,
    focused: false,
    layoutH: 0,
    visualH: 0,
    innerH: 0,
  });

  // const [messages, setMessages] = useState<Message[]>([]);
  const [messages, setMessages] = useState<any>([]);
  const [text, setText] = useState("");
  const [attendeeNum, setAttendeeNum] = useState(0);
  const [channel, setChannel] = useState<any>(null);
  const { getUserData, getInteractions, getLiveMainData, getControls } =
    useAppAccessor();
  const { rtmTokenData, createStreamData, joinData, hostTime, isHostConnected } =
    getLiveMainData();
  const { isCameraOn, isMicOn, isScreenSharing, isHostMicOn } = getControls();
  const { user } = getUserData();
  const { interactionData, activityInteractionData, selectedInteraction, productDetail } =
    getInteractions();
  const { publicUserData } = user;
  const [userConnect, setUserConnect] = useState({});
  const [memberJoin, setMemberJoin] = useState(null);
  const [memberLeft, setMemberLeft] = useState(null);
  const [isChatOn, setIsChatOn] = useState(false);
  const [newMsgComes, setNewMsgComes] = useState(false);
  const [interactionDataArray, setInteractionDataArray] = useState<any>([]);
  const [loged, setLoged] = useState(false);
  const [joinedUser, setJoinedUser] = useState<any>({});
  const [leftUser, setLeftUser] = useState<any>({});
  const [joinedUserArray, setJoinedUserArray] = useState<any>([]);
  const lastBroadcastPinnedLayoutUid = useRef<number | null | undefined>(undefined);
  const {
    showAttendeeCount,
    uid,
    coPresenterInfo,
    coPresenterUids,
    roleCopresenter,
    pinnedLayoutUid,
  } = getControls();
  const { streamState, allAttendeeList } = getLiveMainData();
  const { navigate } = useAppNavigation();
  const isInteractionAdded = useRef(false);
  const { language } = getUserData();
  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
    let currentProduct : any = [];

  const appendMessage = (message: {
    text: string;
    uid: string;
    createAt: string;
    type?: string;
    firstName?: string;
    lastName?: string;
  }) => {
    if (message.type == "TEXT") {
      setMessages((messages: any) => [...messages, message]);
    }
  };


  const updateAttendeeList = async () => {
    var _attendees = await channel?.getMembers();
    var _attendeeList = [];
    // allAttendeeList deepCopy
    var _allAttendeeList = JSON.parse(JSON.stringify(allAttendeeList));
    // var _allAttendeeList = [...allAttendeeList];
    for (var i = 0; _attendees && i < _attendees.length; i++) {
      var userAttribute = await client?.getUserAttributes(_attendees[i]);
      _attendeeList.push(userAttribute);
      if (
        _allAttendeeList.findIndex(
          (item: any) => item.uid == userAttribute.uid
        ) == -1
      ) {
        _allAttendeeList.push(userAttribute);
      }
    }
    if (_allAttendeeList.length > allAttendeeList.length) {
      dispatch(setAttendeeList(_attendeeList));
      dispatch(setAllAttendeeList(_allAttendeeList));
    }
  };

  const addOrUpdateChannelAttributes = async (key: string, value: string) => {
    if (!channel) return;
    try {
      await client?.addOrUpdateChannelAttributes(
        channel?.channelId,
        { [key]: value },
        { enableNotificationToChannelMembers: true }
      );
    } catch (err) {
     // console.log(err);
    }
  };

  const parsePinnedLayoutUid = (rawValue: any): number | null => {
    if (rawValue === undefined || rawValue === null || rawValue === "" || rawValue === "null") {
      return null;
    }
    const parsedValue = Number(rawValue);
    return Number.isNaN(parsedValue) ? null : parsedValue;
  };

  useEffect(()=>{
    if(productDetail && productDetail?.fromCarsoul) {
      props.setInteractionsBottom(true);
    }

  },[productDetail])

  useEffect(() => {
    if (productDetail?.fromCarsoul) {
      if(productDetail) {
        props.setInteractionsBottom(true);
      }
    }
  }, [productDetail?.fromCarsoul12]);

  useEffect(() => {
    updateAttendeeList();
    let interval = setInterval(() => {
      updateAttendeeList();
    }, 1000);
    return () => {
      clearInterval(interval);
    };
  }, [channel, allAttendeeList]);

  useEffect(() => {
    if (isHost()) {
      broadcastHostState(!isCameraOn, "HOST_TURNOFF_CAM");
    }
    if (channel && channel.channelId) {
      client.getChannelAttributes(channel.channelId).then((data: any) => {
        if (data.hasOwnProperty("host_copresenter_info")) {
          var oldVal = JSON.parse(data.host_copresenter_info.value);
          for (var i = 0; i < oldVal.length; i++) {
            if (oldVal[i].uid == uid) {
              oldVal[i].videoOff = !isCameraOn;
              break;
            }
          }
          addOrUpdateChannelAttributes(
            "host_copresenter_info",
            JSON.stringify(oldVal)
          );
          dispatch(setCopresenterInfo(oldVal));
        }
      });
    }
  }, [isCameraOn]);

  useEffect(() => {
    if (isHost()) {
      broadcastHostState(!isMicOn, "HOST_TURNOFF_MIC");
    }
    if (channel && channel.channelId) {
      client.getChannelAttributes(channel.channelId).then((data: any) => {
        if (data.hasOwnProperty("host_copresenter_info")) {
          var oldVal = JSON.parse(data.host_copresenter_info.value);
          for (var i = 0; i < oldVal.length; i++) {
            if (oldVal[i].uid == uid) {
              oldVal[i].micOff = !isMicOn;
              break;
            }
          }
          addOrUpdateChannelAttributes(
            "host_copresenter_info",
            JSON.stringify(oldVal)
          );
          dispatch(setCopresenterInfo(oldVal));
        }
      });
    }
  }, [isMicOn]);

  useEffect(() => {
    if (channel && channel.channelId) {
      client.getChannelAttributes(channel.channelId).then((data: any) => {
        if (data.hasOwnProperty("host_copresenter_info")) {
          var oldVal = JSON.parse(data.host_copresenter_info.value);
          for (var i = 0; i < oldVal.length; i++) {
            if (oldVal[i].uid == uid) {
              oldVal[i].isScreenSharing = isScreenSharing;
              break;
            }
          }
          addOrUpdateChannelAttributes(
            "host_copresenter_info",
            JSON.stringify(oldVal)
          );
          dispatch(setCopresenterInfo(oldVal));
        }
      });
    }
  }, [isScreenSharing]);

  useEffect(() => {
    if (isHost()) {
      addOrUpdateChannelAttributes(
        "SHOW_ATTENDEE",
        showAttendeeCount == true ? "true" : "false"
      );
    }
  }, [showAttendeeCount]);

  useEffect(() => {
    if (uid == -1 || !channel) return;
    if (isHost() || roleCopresenter == true) {
      client.getChannelAttributes(channel.channelId).then((data: any) => {
        if (data.hasOwnProperty("host_copresenter_uids")) {
          addOrUpdateChannelAttributes(
            "host_copresenter_uids",
            JSON.stringify([
              ...JSON.parse(data.host_copresenter_uids.value),
              uid,
            ])
          );
          dispatch(
            setCopresenterUids(JSON.parse(data.host_copresenter_uids.value))
          );
        } else {
          addOrUpdateChannelAttributes(
            "host_copresenter_uids",
            JSON.stringify([uid])
          );
          dispatch(setCopresenterUids([uid]));
        }

        if (data.hasOwnProperty("host_copresenter_info")) {
          var newVal = [
            ...JSON.parse(data.host_copresenter_info.value),
            {
              uid: uid,
              micOff: !isMicOn,
              videoOff: !isCameraOn,
              isScreenSharing: isScreenSharing,
              firstName: publicUserData?.family_name,
              lastName: publicUserData?.given_name,
            },
          ];
          addOrUpdateChannelAttributes(
            "host_copresenter_info",
            JSON.stringify(newVal)
          );
          dispatch(setCopresenterInfo(newVal));
        } else {
          addOrUpdateChannelAttributes(
            "host_copresenter_info",
            JSON.stringify([
              {
                uid: uid,
                micOff: !isMicOn,
                videoOff: !isCameraOn,
                isScreenSharing: isScreenSharing,
                firstName: publicUserData?.family_name,
                lastName: publicUserData?.given_name,
              },
            ])
          );
          dispatch(
            setCopresenterInfo([
              {
                uid: uid,
                micOff: !isMicOn,
                videoOff: !isCameraOn,
                isScreenSharing: isScreenSharing,
                firstName: publicUserData?.family_name,
                lastName: publicUserData?.given_name,
              },
            ])
          );
        }
      });
    } else {
      client.getChannelAttributes(channel.channelId).then((data: any) => {
        if (data.hasOwnProperty("host_copresenter_uids")) {
          addOrUpdateChannelAttributes(
            "host_copresenter_uids",
            JSON.stringify([...JSON.parse(data.host_copresenter_uids.value)])
          );
          dispatch(
            setCopresenterUids(JSON.parse(data.host_copresenter_uids.value))
          );
        }

        if (data.hasOwnProperty("host_copresenter_info")) {
          var newVal = [...JSON.parse(data.host_copresenter_info.value)];
          addOrUpdateChannelAttributes(
            "host_copresenter_info",
            JSON.stringify(newVal)
          );
          dispatch(setCopresenterInfo(newVal));
        }
      });
    }
  }, [uid, channel]);

  useEffect(() => {
    if (isHost() && streamState === "ended") {
      if (isHost()) {
       // console.log("===========stream-end========");
        broadcastHostState(true, "stream-end");
      } else {
        channel?.leave();
        client?.logout();
      }
    }

    if (
      streamState === "ended" &&
      window.location.href.indexOf("/login") > -1
    ) {
      broadcastHostState(true, "stream-end");
    }
  }, [streamState]);

  useEffect(() => {
    setUserConnect(publicUserData);
  }, [publicUserData?.userId]);

  useEffect(() => {
    if (isHost() === false) {
      dispatch(setInteractionData(interactionDataArray));
    }
  }, [interactionDataArray]);

  useEffect(() => {
   // console.log("InteractionsIN Chat=====>", interactionData);

    if (interactionData.length > 0) {
      if (isHost() === true) {
        isInteractionAdded.current = true;

        sendInteractionMessages(JSON.stringify(interactionData));
      }
    } else if (interactionData.length == 0) {
      if (isInteractionAdded.current) {
        isInteractionAdded.current = false;

        sendInteractionMessages(JSON.stringify(interactionData));
      }
    }
  }, [interactionData]);

  useEffect(() => {
    if (isHost() === true) {
      sendHostTime(hostTime);
    }

    channel?.getMembers().then((data: any) => {
      dispatch(setPersonNum(data.length));
    });

    updateAttendeeList();
  }, [attendeeNum]);

  useEffect(() => {
    if (isHost() === true) {
      sendActivityInteractionMessages(
        JSON.stringify(joinedUser),
        `${joinedUser.firstName} ${joinedUser.lastName} has joined`,
        "user joined"
      );

      setTimeout(() => {
        sendHistoryMessages();
        sendInteractionMessages(JSON.stringify(interactionData));
      }, 1000);
    }
  }, [joinedUser]);

  useEffect(() => {
    if (isHost() === true) {
      sendActivityInteractionMessages(
        JSON.stringify(leftUser),
        `${leftUser.firstName} ${leftUser.lastName} has Left`,
        "user left"
      );
    }
   // console.log(leftUser);
  }, [leftUser]);

  useEffect(() => {
    // host left the stream
    window.addEventListener("unload", async function (event) {
      if (isHost()) {
        await dispatch(setStramState("ended"));
        event.preventDefault();
      }
    });
  });

  useEffect(() => {
    if (isHost() === false) {
      let objUserTemp: any = {
        firstName: publicUserData?.given_name,
        lastName: publicUserData?.family_name,
        avatar:
          publicUserData?.picture ??
          "https://s3-us-west-2.amazonaws.com/investo-bucket/default_avatar.png",
        id: publicUserData.userId ?? joinData.attendee_id,
        uid: rtmTokenData?.user_id,
        email: publicUserData?.email,
      };
      sendActivityInteractionMessages(
        JSON.stringify(objUserTemp),
        `${objUserTemp?.firstName} ${objUserTemp?.lastName} has clicked on ${selectedInteraction?.attributes?.label}`,
        "interaction clicked"
      );
    }
  }, [selectedInteraction]);

  const connect = async (rtmTokenData: any, stream_instance_id: string) => {
    if (rtmTokenData.user_id && rtmTokenData.token && stream_instance_id) {
      setLoged(true);
      await client.login({
        uid: rtmTokenData.user_id,
        token: rtmTokenData.token,
      });
      await client.setLocalUserAttributes({
        firstName:
          publicUserData?.given_name && publicUserData?.given_name.length > 0
            ? publicUserData?.given_name
            : "Anonymous",
        lastName:
          publicUserData?.family_name && publicUserData?.family_name.length > 0
            ? publicUserData?.family_name
            : "User",
        avatar:
          publicUserData?.picture && publicUserData?.picture.length > 0
            ? publicUserData?.picture
            : "https://s3-us-west-2.amazonaws.com/investo-bucket/default_avatar.png",
        id:
          publicUserData?.userId && publicUserData?.userId.length > 0
            ? publicUserData?.userId
            : joinData.attendee_id,
        uid: rtmTokenData?.user_id,
        email:
          publicUserData?.email && publicUserData?.email.length > 0
            ? publicUserData?.email
            : "",
      });
      const channel = await client.createChannel(stream_instance_id);
      await channel.join();
      client.getChannelAttributes(channel.channelId).then((data: any) => {
        if (data.hasOwnProperty("SHOW_ATTENDEE")) {
          dispatch(
            showAttendeeCountFunc(
              data.SHOW_ATTENDEE.value == "true" ? true : false
            )
          );
        }
        if (data.hasOwnProperty("host_copresenter_uids")) {
          dispatch(
            setCopresenterUids(JSON.parse(data.host_copresenter_uids.value))
          );
        }
        if (data.hasOwnProperty("host_copresenter_info")) {
          dispatch(
            setCopresenterInfo(JSON.parse(data.host_copresenter_info.value))
          );
        }
        if (data.hasOwnProperty(PINNED_PRESENTER_UID_KEY)) {
          dispatch(
            setPinnedLayoutUid(parsePinnedLayoutUid(data[PINNED_PRESENTER_UID_KEY].value))
          );
        }
        // Monitor host connection status for attendees (initial check)
        if (data.hasOwnProperty("host_connection_status") && !isHost()) {
          const isConnected = data.host_connection_status.value === "connected";
          dispatch(setHostConnectionStatus(isConnected));
        }
      });
      
      // Broadcast initial connection status when host joins (set as connected)
      if (isHost()) {
        addOrUpdateChannelAttributes("host_connection_status", "connected");
      }
      
      channel.on("ChannelMessage", async (message: any, peerId, memberId) => {
        if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == null
        ) {
          var userAttribute = await client?.getUserAttributes(peerId);
          appendMessage({
            text: JSON.parse(message.text).text,
            uid: userAttribute.uid,
            createAt: new Date().toLocaleTimeString([], { timeStyle: "short" }),
            type: "TEXT",
          });
          setNewMsgComes(true);
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "interactions"
        ) {
          const messageData = JSON.parse(message.text);
          const interactionData = typeof messageData.interaction === 'string'
          ? JSON.parse(messageData.interaction)
          : messageData.interaction; // If it's already an object, no need to parse
         // console.log(
          //   "[AGORA CHAT] Agora plain message",
          //   messageData
          // );
          setInteractionDataArray(interactionData);
          var products_MA = interactionData.filter((item: any) => item.real_type === "shop_com");
          var products_PartnerCo = interactionData.filter((item: any) => item?.attributes?.siteName?.toLowerCase().trim() === "partner.co");

          if(products_MA.length > 0) {
            const isReloadProductRequire = !_.isEqual(products_MA, currentProduct);

            if(isReloadProductRequire) {
              currentProduct = products_MA;
              var hostData = localStorage.getItem("hostData");
              getItemDetailService(products_MA.map((item: any) => item.interaction_id).join(','), hostData!)?.then((res: any) => {
                dispatch(getProductDetails(res));
              }).catch((err: any) => {
                console.log(err);
              });
            }
          } else if (products_PartnerCo.length > 0){
            currentProduct = products_PartnerCo;

            getItemDetailServiceForPartnerCo(products_PartnerCo.map((item: any) => item.interaction_id).join(','), products_PartnerCo[0]?.attributes?.locale, "morinda")?.then((res: any) => {
              dispatch(getProductDetails(res.data.map((item: any) => ({...item, locale: products_PartnerCo[0]?.attributes?.locale}))));
            }).catch((err: any) => {
              console.log(err);
            });
          } 
          else {
            var products_Tranont = interactionData.filter((item: any) => item?.attributes?.siteName?.toLowerCase().trim() === "trannont");

              currentProduct = products_Tranont;
              
              var hostData = localStorage.getItem("hostData");

              var isNfrProduct = products_Tranont.some((item: any) => !!item?.attributes?.nfr);

              getItemDetailServiceTranont(products_Tranont.map((item: any) => item.interaction_id).join(','), isNfrProduct, products_Tranont[0]?.attributes?.locale, "tranont")?.then((res: any) => {
                dispatch(getProductDetails(res.data.map((item: any) => ({...item, locale: products_Tranont[0]?.attributes?.locale, nfr: products_Tranont[0]?.attributes?.nfr}))));
              }).catch((err: any) => {
                console.log(err);
              });
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "startedStreamingTime"
        ) {
          if (!isHost()) {
            dispatch(setHostTime(JSON.parse(message.text).text));
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "activity"
        ) {
         // console.log(
          //   "interaction===>In Attendee==>ACTIVITY",
          //   JSON.parse(message.text)
          // );
          setActivityInteraction(JSON.parse(message.text));
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "HOST_TURNOFF_MIC"
        ) {
         // console.log(
          //   "interaction===>In Attendee==>HOST_TURNOFF_MIC",
          //   JSON.parse(message.text)
          // );
          if (JSON.parse(message.text).text == "true") {
           // console.log("turn off mic");
            dispatch(turnOffHostMic());
            dispatch(toastMess(language['host_mic_muted']));
            setTimeout(() => {
              dispatch(toastMess(""));
            }, 5000);
          } else {
           // console.log("turn on mic");
            dispatch(toastMess("Host microphone is active"));
            dispatch(turnOnHostMic());
            setTimeout(() => {
              dispatch(toastMess(""));
            }, 1500);
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "HOST_TURNOFF_CAM"
        ) {
         // console.log(
          //   "interaction===>In Attendee==>HOST_TURNOFF_CAM",
          //   JSON.parse(message.text)
          // );
          if (JSON.parse(message.text).text == "true") {
            dispatch(turnOffHostCamera());
          } else {
            dispatch(turnOnHostCamera());
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "host_connection_status"
        ) {
          // Handle host connection status updates for attendees
          if (!isHost()) {
            const messageData = JSON.parse(message.text);
            const isConnected = messageData.connected === true;
            dispatch(setHostConnectionStatus(isConnected));
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "stream-end"
        ) {
         // console.log(
          //   "interaction===>In Attendee==>HOST_TURNOFF_CAM",
          //   JSON.parse(message.text)
          // );
          if (JSON.parse(message.text).text == "true") {
            if (isHost()) {
              navigate({ screen: screens.public.endLive });
              setTimeout(() => {
                window.location.reload();
              }, 100);
            } else {
              dispatch(setStramState("hostEnding"));
            }
          }
        } else if (
          message.messageType == "TEXT" &&
          JSON.parse(message.text).actionType == "historyMessage"
        ) {
          if (!isHost() && !hisotryMSG) {
            setMessages((JSON.parse(message.text).interaction));
            setHistoryMSG(true);
          }
        }
      });
      channel.on("MemberJoined", (memberId: any) => {
        if (isHost()) {
          // dispatch(setHostTime(hostTime+1));
         // console.log("MemberJoined===>##", memberId);
          getJoinedUserDetails(memberId, true);
          // callPostAttendeeNumber(id!, attendeeNum + 1);
          // sendHostTime(hostTime);
          setAttendeeNum((num) => num + 1);
        }
        setMemberJoin(memberId);
      });
      channel.on("MemberLeft", (memberId: any) => {
       // console.log("MemberLeft===>##", memberId);
        setMemberLeft(memberId);
        // callPostAttendeeNumber(id!, attendeeNum);
        setAttendeeNum((num) => num - 1);
      });
      channel.on("AttributesUpdated", (data: any) => {
        if (data.hasOwnProperty("SHOW_ATTENDEE")) {
          dispatch(
            showAttendeeCountFunc(
              data.SHOW_ATTENDEE.value == "true" ? true : false
            )
          );
        }
        if (data.hasOwnProperty("host_copresenter_uids")) {
          dispatch(
            setCopresenterUids(JSON.parse(data.host_copresenter_uids.value))
          );
        }
        if (data.hasOwnProperty("host_copresenter_info")) {
          dispatch(
            setCopresenterInfo(JSON.parse(data.host_copresenter_info.value))
          );
        }
        if (data.hasOwnProperty(PINNED_PRESENTER_UID_KEY)) {
          dispatch(
            setPinnedLayoutUid(parsePinnedLayoutUid(data[PINNED_PRESENTER_UID_KEY].value))
          );
        }
        // Monitor host connection status updates for attendees
        if (data.hasOwnProperty("host_connection_status") && !isHost()) {
          const isConnected = data.host_connection_status.value === "connected";
          dispatch(setHostConnectionStatus(isConnected));
        }
      });

      channel?.getMembers().then((data: any) => {
        dispatch(setPersonNum(data.length));
      });

      setChannel(channel);
      (window as any).agoraRTMChannel = channel;
      
      return channel;
    }
  };

  const getJoinedUserDetails = async (userId: any, isJoined: any) => {
    var userAttribute = await client?.getUserAttributes(userId);
   // console.log("userAttribute==>USERJOINED", userAttribute);
    if (isJoined) {
      setJoinedUser(userAttribute);
    } else {
      setLeftUser(userAttribute);
    }
  };

  const setActivityInteraction = (data: any) => {
    setJoinedUserArray((prevArray: any) => [...prevArray, data]);
  };

  useEffect(() => {
   // console.log("activityDta===>", joinedUserArray);
    dispatch(setActivityInteractionData(joinedUserArray));
  }, [joinedUserArray]);

  useEffect(() => {
   // console.log("userdata===>Redux", activityInteractionData);
  }, [activityInteractionData]);

  useEffect(() => {
    if (isHost() === true) {
      connect(rtmTokenData, createStreamData.stream_instance_id);

      return () => {
        const disconnect = async () => {
          // const channel = await connect(rtmTokenData, createStreamData.stream_instance_id);
          await channel?.leave();
          if (loged) {
            await client?.logout();
            setLoged(false);
          }
        };
        disconnect();
      };
    }
  }, [rtmTokenData, createStreamData]);

  useEffect(() => {
   // console.log("JOIN___DATA====>", joinData);
    if (isHost() === false) {
      if (!isMobile) {
        connect(rtmTokenData, joinData.stream_instance_id);

        return () => {
          const disconnect = async () => {
            const channel = await connect(
              rtmTokenData,
              joinData.stream_instance_id
            );
            await channel?.leave();
            if (loged) {
              await client?.logout();
              setLoged(false);
            }
          };
          disconnect();
        };
      } else {
        if (!loged) {
          connect(rtmTokenData, joinData.stream_instance_id);
        }

        return () => {
          const disconnect = async () => {
            if (loged) {
              const channel = await connect(
                rtmTokenData,
                joinData.stream_instance_id
              );
              await channel?.leave();
            }
            if (loged) {
             // console.log("789");
              await client?.logout();
              setLoged(true);
            }
          };
          disconnect();
        };
      }
    }
  }, [rtmTokenData, joinData]);

  useEffect(() => {
    if (rtmTokenData.token) {
      setIsChatOn(true);
    }
  }, [rtmTokenData]);

  // Broadcast host connection status via RTM when it changes (host side only)
  useEffect(() => {
    if (isHost() && channel && typeof isHostConnected !== 'undefined') {
      const status = isHostConnected ? "connected" : "disconnected";
      // Update channel attributes
      addOrUpdateChannelAttributes("host_connection_status", status);
      // Also send RTM message for more reliable real-time updates
      channel?.sendMessage({
        text: JSON.stringify({
          actionType: "host_connection_status",
          connected: isHostConnected
        }),
        messageType: "TEXT",
      });
    }
  }, [isHostConnected, channel]);

  useEffect(() => {
    if (!channel || !channel.channelId) {
      return;
    }
    if (!(isHost() || roleCopresenter)) {
      return;
    }
    if (lastBroadcastPinnedLayoutUid.current === pinnedLayoutUid) {
      return;
    }

    const rawPinnedValue =
      pinnedLayoutUid === null || typeof pinnedLayoutUid === "undefined"
        ? "null"
        : String(pinnedLayoutUid);

    addOrUpdateChannelAttributes(PINNED_PRESENTER_UID_KEY, rawPinnedValue)
      .then(() => {
        lastBroadcastPinnedLayoutUid.current = pinnedLayoutUid;
      })
      .catch((err) => {
        console.error("Error updating pinned presenter uid:", err);
      });
  }, [pinnedLayoutUid, channel?.channelId, roleCopresenter]);

  const sendMessage = (e: any) => {
    // e.preventDefault();
    if (text === "") return;
    channel?.sendMessage({
      text: `{\"from\":\"${firstName} ${lastName}\",\"toId\":null,\"text\":\"${text}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":null,\"shouldFeatureInteraction\":false,\"interaction\":null}`,
      messageType: "TEXT",
    });
    var firstName = publicUserData?.given_name;
    var lastName = publicUserData?.family_name;
    appendMessage({
      text: text,
      uid: rtmTokenData.user_id,
      createAt: new Date().toLocaleTimeString([], { timeStyle: "short" }),
      type: "TEXT",
      firstName: firstName,
      lastName: lastName,
    });
    setText("");
  };

  const sendInteractionMessages = (interactionData: any) => {
    if (interactionData == null) return;
    // channel?.sendMessage({ text, messageType: "INTERACTION" });
    channel?.sendMessage({
      text: `{\"from\":\"d z\",\"toId\":null,\"text\":\"${null}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${"interactions"}\",\"shouldFeatureInteraction\":false,\"interaction\":${interactionData}}`,
      messageType: "TEXT",
    });
    // appendMessage({
    //   text: interactionData,
    //   uid,
    //   createAt: new Date().toLocaleTimeString([], { timeStyle: "short" }),
    //   type: 'INTERACTION'
    // });
  };

  const sendHistoryMessages = () => {
    // channel?.sendMessage({ text, messageType: "INTERACTION" });
    // var text = JSON.stringify(messages);
    // channel?.sendMessage({
    //   text: `{\"from\":\"d z\",\"toId\":null,\"text\":\"${text}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${"historyMessage"}\",\"shouldFeatureInteraction\":false,\"interaction\":${interactionData}}`,
    //   messageType: "TEXT",
    // });
    // appendMessage({
    //   text: interactionData,
    //   uid,
    //   createAt: new Date().toLocaleTimeString([], { timeStyle: "short" }),
    //   type: 'INTERACTION'
    // });
  };

  const isEmpty = (obj: any) => {
    for (const prop in obj) {
      if (Object.hasOwn(obj, prop)) {
        return false;
      }
    }

    return true;
  };

  const sendActivityInteractionMessages = (
    activityData: any,
    typeText: any,
    action: any
  ) => {
   // console.log("activityDDDDD==>", activityData);
    let tempObje: any = activityData;
   // console.log("activityDDDDD==>Temp", JSON.parse(tempObje)?.firstName);

    // channel?.sendMessage({ text, messageType: "INTERACTION" });
    // channel?.sendMessage({ text:`{\"from\":\"${activityData}\",\"toId\":null,\"text\":\"${typeText}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":${action},\"actionType\":\"${'activity'}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`, messageType: "TEXT" });
    if (JSON.parse(tempObje)?.firstName != undefined) {
      channel?.sendMessage({
        text: `{\"from\":${activityData},\"toId\":null,\"text\":\"${typeText}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${"activity"}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`,
        messageType: "TEXT",
      });

      if (isHost() === true) {
        let dataTemp: any = `{\"from\":${activityData},\"toId\":null,\"text\":\"${typeText}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${"activity"}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`;
        setActivityInteraction(JSON.parse(dataTemp));
      }
    }
  };

  const sendHostTime = (time: number) => {
    channel?.sendMessage({
      text: `{\"from\":\"d z\",\"toId\":null,\"text\":\"${String(
        time
      )}\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${"startedStreamingTime"}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`,
      messageType: "TEXT",
    });
  };

  const broadcastHostState = (status: boolean, actionType: String) => {
    channel?.sendMessage({
      text: `{\"from\":\"d z\",\"toId\":null,\"text\":\"${
        status ? "true" : "false"
      }\",\"timestamp\":\"2023-09-21T01:22:21.435265\",\"action\":null,\"actionType\":\"${actionType}\",\"shouldFeatureInteraction\":false,\"interaction\":null}`,
      messageType: "TEXT",
    });
  };

  const dynamicHeader = (activeTab: string) => {
    switch (activeTab) {
      case "chat":
        return "Chat";
      case "attendees":
        return "Attendees";
      case "activity":
        return "Activity";
      default:
        return "Chat";
    }
  };

  const onChangeActiveTab = (activeTab: string) => {
    setActiveTab(activeTab);
  };

  const onChangeText = (e: any) => {
    setText(e);
  };

  useEffect(() => {
    if (isMobile && !isAndroid()) startKeyboardTracking();
  }, [isMobile]);

  useEffect(() => {
    if (!isMobile || !isChatInputFocused) {
      setKeyboardOffset(0);
      const vv = window.visualViewport;
      setDebugViewport({
        layoutH: baselineLayoutH || window.innerHeight,
        visualH: vv?.height ?? 0,
        innerH: window.innerHeight,
        offset: 0,
        focused: isChatInputFocused,
      });
      return;
    }
    if (isAndroid()) {
      setKeyboardOffset(0);
      return;
    }
    const unsubscribe = subscribeKeyboard((keyboardH) => {
      const vv = window.visualViewport;
      setKeyboardOffset(keyboardH);
      setDebugViewport({
        layoutH: baselineLayoutH,
        visualH: vv?.height ?? 0,
        innerH: window.innerHeight,
        offset: keyboardH,
        focused: true,
      });
      if (process.env.NODE_ENV !== "production") {
        console.debug("[agora-chat-mobile] viewport", {
          baselineLayoutH,
          baselineInnerHeight,
          visualH: vv?.height,
          innerH: window.innerHeight,
          keyboardH,
        });
      }
    });
    return () => {
      unsubscribe();
      setKeyboardOffset(0);
      setDebugViewport((prev) => ({ ...prev, layoutH: 0, visualH: 0, innerH: 0, offset: 0, focused: false }));
    };
  }, [isMobile, isChatInputFocused]);

  const handleChatInputFocus = () => {
    if (!isAndroid()) startKeyboardTracking();
    setChatInputFocused(true);
    if (props.onChatInputFocusChange && !isAndroid()) {
      props.onChatInputFocusChange(true);
    }
  };

  const handleChatInputBlur = () => {
    setChatInputFocused(false);
    if (props.onChatInputFocusChange && !isAndroid()) {
      props.onChatInputFocusChange(false);
    }
  };

  useEffect(() => {
    if (props.onMessagesChange) {
      props.onMessagesChange(messages);
    }
  }, [messages, props.onMessagesChange]);

  return (
    <>
  <div
    className="flex flex-row justify-center items-center absolute w-full bottom-5 bg-[#202121]/[0] pl-2 pr-2 pt-2 pb-2 rounded-full"
    style={{
      position: "fixed",
      bottom: "0px",
      zIndex: 100,
      transform: keyboardOffset ? `translateY(-${keyboardOffset}px)` : undefined,
      transition: "transform 0.15s ease-out",
    }}
  >
     <div className=" flex bottom-30 w-full left-0 right-0"
          style={{width:'calc(100% - 100px)', height:'50px', marginLeft:'8px', border: '1px solid white', borderRadius: '8px'}}
          >
            <Chatbox
              sendMessage={sendMessage}
              onChangeText={onChangeText}
              textValue={text}
              isChatOn={isChatOn}
              onInputFocus={handleChatInputFocus}
              onInputBlur={handleChatInputBlur}
            />
          </div>
          <div style={{width:'12px'}}></div>
          <div
            className="flex justify-center items-center pl-2 pr-2 pt-2 pb-2 relative"
            style={{ zIndex: 99, background: 'transparent', width: '50px', height: '50px', border: '1px solid white', borderRadius: '8px' }}
            onClick={() => {
              // setModalBottom(!modalBottom);
              setNewMsgComes(false);
              props.setModalBottom(props.modalIsOpen);
            }}
          >
            <img className="h-7" src={Chatnew} />
            {
              !props.modalIsOpen && newMsgComes && <span
                className="absolute top-0 right-0 h-4 w-4 bg-red-500 rounded-full"
              ></span>
            }
            
          </div>
            <div style={{width:'12px'}}></div>
            <div
              className="flex justify-center items-center pl-2 pr-2 pt-2 pb-2"
              style={{ zIndex: 99 ,background:'transparent', width:'50px', height:'50px', border: '1px solid white', borderRadius:'8px'}}
              onClick={() => {
                // setInteractionsBottom(true);
                props.setInteractionsBottom(true);
              }}
            >
              <img src={List} />
            </div>

            <div style={{width:'8px'}}></div>
  </div>
    </>
  );
};

export default AgoraChatMobile;
